import { Wetter } from './wetter';

export class TagebuchEintrag {
  constructor({
    standortId,
    datum,
    wetter,
    interneNotiz,
  }: {
    standortId: string;
    datum: string;
    wetter: Wetter[];
    interneNotiz: string;
  }) {
    this.standortId = standortId;
    this.datum = datum;
    this.wetter = wetter;
    this.interneNotiz = interneNotiz;
  }
  readonly standortId: string;
  readonly datum: string;
  readonly wetter: Wetter[];
  readonly interneNotiz: string;
}
